/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RequestAddSystemAdminRole400ResponseErrors
 */
export interface RequestAddSystemAdminRole400ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof RequestAddSystemAdminRole400ResponseErrors
     */
    'reason': RequestAddSystemAdminRole400ResponseErrorsReasonEnum;
}

export const RequestAddSystemAdminRole400ResponseErrorsReasonEnum = {
    notSpecifiedRole: 'NOT_SPECIFIED_ROLE',
    notFoundUser: 'NOT_FOUND_USER',
    notFoundRole: 'NOT_FOUND_ROLE',
    alreadyRegistered: 'ALREADY_REGISTERED',
    notCoveredOrganization: 'NOT_COVERED_ORGANIZATION'
} as const;

export type RequestAddSystemAdminRole400ResponseErrorsReasonEnum = typeof RequestAddSystemAdminRole400ResponseErrorsReasonEnum[keyof typeof RequestAddSystemAdminRole400ResponseErrorsReasonEnum];


